module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('component-header', {
    attrs: {
      "title": "Block",
      "description": "Stacked image-with-text object. A simple abstraction to cover a very commonly occurring design pattern."
    }
  }), _vm._v(" "), _c('Block', _vm._b({}, 'Block', {
    src: _vm.src,
    alt: _vm.alt
  }, false), [_vm._v("\n    " + _vm._s(_vm.slot) + "\n  ")]), _vm._v(" "), _vm._l((_vm.optionalProps), function(prop, propName) {
    return _c('div', {
      key: propName
    }, [_c('h2', [_vm._v(_vm._s(propName) + " modifier")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('pre', [_vm._v("prop: "), _c('b', [_vm._v(_vm._s(propName))])]), _vm._v(" "), _vm._l((prop), function(value) {
      return _c('div', {
        key: value,
        staticClass: "object-wrapper"
      }, [_c('h3', [_vm._v(_vm._s(value))]), _vm._v(" "), _c('Block', _vm._b({}, 'Block', ( _obj = {
        src: _vm.src,
        alt: _vm.alt
      }, _obj[propName] = value, _obj ), false), [_vm._v("\n        " + _vm._s(_vm.slot) + "\n      ")])], 1)
      var _obj;
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-220cd6a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/BlockShowcase.vue
// module id = 55
// module chunks = 0